import { render } from "./donutchart.vue?vue&type=template&id=3aea80db"
import script from "./donutchart.vue?vue&type=script&lang=js"
export * from "./donutchart.vue?vue&type=script&lang=js"

import "./donutchart.vue?vue&type=style&index=0&id=3aea80db&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__